import { z } from 'zod';

/**
 * Shared validation schemas for the simple Ops Configs resources
 * (Ops Service, Cash Service, Cash Vault Branch) — all of which have the
 * same `name` / `description` create shape and add `is_active` on edit.
 */
export const configResourceCreateSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string().min(1, 'Description is required'),
});

export const configResourceEditSchema = configResourceCreateSchema.extend({
  is_active: z.boolean(),
});

export type ConfigResourceCreateSchemaType = z.infer<typeof configResourceCreateSchema>;
export type ConfigResourceEditSchemaType = z.infer<typeof configResourceEditSchema>;
